export default __webpack_public_path__ + "static/media/registration-blue.fa993f6d.svg";